import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import ParkingAreaType from "../../../../commons/model/ParkingAreaType";
import { generateRoute } from "../../../../commons/utils/Router";
import ActiveLabel from "../../../../components/label/ActiveLabel";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_PARKING_AREA_TYPE_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface ParkingAreaTypeListTableProps {
    data: ParkingAreaType[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_COMPANY_USER_PARKING_AREA_TYPE_DETAIL, {
    id: itemId,
  } ));
};

export default class ParkingAreaTypeCompanyUserListTable extends React.Component<ParkingAreaTypeListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((parkingAreaType: ParkingAreaType) => (
            <tr key={parkingAreaType.id}
              onClick={() => goToItemDetail(parkingAreaType.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(parkingAreaType.id) : null}
              <td>
                {parkingAreaType.name}
              </td>
              <td>
                <ActiveLabel
                  text={I18n.tr(parkingAreaType.enabled ? I18nKeys.HABILITADA : I18nKeys.DESAHABILITADA)}
                  active={parkingAreaType.enabled}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.NOMBRE)}
          columnName={"name"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.ESTADO)}
          columnName={"enabled"}
          {...commonProps}
        />
      </tr>
    );
  }
}
